// extracted by mini-css-extract-plugin
export var banner = "_ou-0";
export var settingRow = "_ou-2";
export var titleIcon = "_ou-1";